export default __webpack_public_path__ + "static/media/Hair_2_M_C3.2b1cd2cd.svg";